import React from 'react';

function LegendItem({ icon, label }) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex shrink-0 items-center justify-center">{icon}</div>
      <span>{label}</span>
    </div>
  );
}

function RiskLegendIcon({ level = 'medium' }) {
  const isHigh = level === 'high';
  return (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path
        d="M14 4 L26 24 L2 24 Z"
        fill={isHigh ? '#dc2626' : '#f59e0b'}
        stroke={isHigh ? '#991b1b' : '#d97706'}
        strokeWidth="1.5"
      />
      <text x="14" y="19" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">!</text>
    </svg>
  );
}

function ControlHexagonLegendIcon({ isKey }) {
  return (
    <svg width="28" height="28" viewBox="0 0 70 70" fill="none" aria-hidden="true">
      <polygon
        points="20,30 35,15 50,30 50,40 35,55 20,40"
        fill={isKey ? '#ea580c' : '#f3e8ff'}
        stroke={isKey ? '#c2410c' : '#c084fc'}
        strokeWidth={isKey ? '2' : '1.5'}
      />
      {isKey ? (
        <text
          x="35"
          y="38"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#ffffff"
          fontSize="10"
          fontWeight="700"
        >
          KEY
        </text>
      ) : null}
    </svg>
  );
}

function SystemLegendIcon({ isKey }) {
  const fillTop = isKey ? '#8b5cf6' : '#bfdbfe';
  const fillBody = isKey ? '#7c3aed' : '#dbeafe';
  const stroke = isKey ? '#5b21b6' : '#93c5fd';
  const strokeWidth = isKey ? 2 : 1.5;
  return (
    <svg width="36" height="22" viewBox="0 0 80 48" fill="none" aria-hidden="true">
      <ellipse cx="40" cy="7" rx="35" ry="7" fill={fillBody} stroke={stroke} strokeWidth={strokeWidth} />
      <rect x="5" y="7" width="70" height="33" fill={fillBody} />
      <ellipse cx="40" cy="40" rx="35" ry="7" fill={fillTop} stroke={stroke} strokeWidth={strokeWidth} />
      <ellipse cx="40" cy="7" rx="35" ry="7" fill={fillTop} stroke={stroke} strokeWidth={strokeWidth} />
      {isKey ? (
        <text
          x="40"
          y="28"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#fde047"
          fontSize="10"
          fontWeight="700"
        >
          KEY
        </text>
      ) : null}
    </svg>
  );
}

function DocumentLegendIcon({ isReport = false }) {
  const fill = isReport ? '#fef3c7' : '#dcfce7';
  const stroke = isReport ? '#f59e0b' : '#86efac';
  const tabFill = isReport ? '#fde047' : '#bbf7d0';
  return (
    <svg width="28" height="28" viewBox="0 0 70 70" fill="none" aria-hidden="true">
      <path
        d="M 10 20 L 30 20 L 35 15 L 60 15 L 60 55 L 10 55 Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path d="M 10 20 L 60 20 L 60 25 L 10 25 Z" fill={tabFill} />
    </svg>
  );
}

function OutputToProcessLegendIcon() {
  return (
    <svg width="18" height="28" viewBox="0 0 18 28" fill="none" aria-hidden="true">
      <line x1="7" y1="0" x2="7" y2="8" stroke="#0f766e" strokeWidth="1.2" strokeDasharray="2 2" />
      <line x1="9" y1="0" x2="9" y2="8" stroke="#0f766e" strokeWidth="1.2" strokeDasharray="2 2" />
      <line x1="11" y1="0" x2="11" y2="8" stroke="#0f766e" strokeWidth="1.2" strokeDasharray="2 2" />
      <rect x="4" y="7" width="10" height="20" rx="5" fill="#0d9488" stroke="#99f6e4" strokeWidth="1.2" />
    </svg>
  );
}

function InputFromProcessLegendIcon() {
  return (
    <svg width="18" height="28" viewBox="0 0 18 28" fill="none" aria-hidden="true">
      <rect x="4" y="1" width="10" height="20" rx="5" fill="#dc2626" stroke="#fecaca" strokeWidth="1.2" />
      <line x1="7" y1="20" x2="7" y2="28" stroke="#b91c1c" strokeWidth="1.2" strokeDasharray="2 2" />
      <line x1="9" y1="20" x2="9" y2="28" stroke="#b91c1c" strokeWidth="1.2" strokeDasharray="2 2" />
      <line x1="11" y1="20" x2="11" y2="28" stroke="#b91c1c" strokeWidth="1.2" strokeDasharray="2 2" />
    </svg>
  );
}

export default function FlowchartLegend() {
  return (
    <div className="shrink-0 border-t border-gray-200 bg-gray-50 px-4 py-2.5">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-gray-600">
        <LegendItem icon={<RiskLegendIcon level="high" />} label="High risk" />
        <LegendItem icon={<RiskLegendIcon level="medium" />} label="Risk" />
        <LegendItem icon={<ControlHexagonLegendIcon isKey />} label="Key control" />
        <LegendItem icon={<ControlHexagonLegendIcon isKey={false} />} label="Non-key control" />
        <LegendItem icon={<SystemLegendIcon isKey />} label="Key system" />
        <LegendItem icon={<SystemLegendIcon isKey={false} />} label="Non-key system" />
        <LegendItem icon={<DocumentLegendIcon />} label="Document" />
        <LegendItem icon={<DocumentLegendIcon isReport />} label="Report" />
        <LegendItem icon={<OutputToProcessLegendIcon />} label="Output to process" />
        <LegendItem icon={<InputFromProcessLegendIcon />} label="Input from process" />
      </div>
    </div>
  );
}
